<template>
  <svg :class="svgClass" aria-hidden="true"  v-on="$listeners" >
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
  export default {
    name: 'SvgIcon',
    props: {
      iconClass: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: ''
      }
    },
    computed: {
      iconName() {
        // console.log('111='+this.iconClass);
        // #icon-iconfont_icon
        // 结合实际生成的文档调整后显示
        return `#icon-iconfont_icon-${this.iconClass}`
      },
      svgClass() {
        // console.log(this.className);
        if (this.className) {
          // console.log('1');
          return 'svg-icon ' + this.className
        } else {
          // console.log('0');
          return 'svg-icon'
        }
      }
    }
  }
</script>

<style scoped>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
